<div class="wrapper">
    <nav class="navbar">
        <img src="assets/logos/logo.svg" alt="Capch logo" class="logo">
        <div class="title">{{navbarTitle}}</div>
        <p-button label="Log out" severity="secondary" (onClick)="logout()" />
    </nav>
    <router-outlet></router-outlet>
</div>